import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  TransferCategory,
  TransferCreate,
  TransferService,
} from "@/domains/transfer";
import { useAppDispatch, useAppSelector } from "@/stores";
import { tenantSelfWithdrawSelects, tenantSelfWithdrawThunks } from "./store";
// components
import { Button, Form, Input, Modal } from "antd";
import { PlusCircleTwoTone } from "@ant-design/icons";

export const CreateModal = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const queryParams = useAppSelector(tenantSelfWithdrawSelects.queryParams);

  const [form] = Form.useForm<TransferCreate>();

  const [isOpen, setIsOpen] = useState(false);

  const handleShow = () => {
    setIsOpen(true);
    form.resetFields();
  };

  const handleConfirm = async () => {
    const formValue = await form.validateFields();

    const data = {
      ...formValue,
      currency: "USDT",
      category: TransferCategory.TenantWithdraw,
    };

    try {
      await TransferService.create(data).run();
      void dispatch(tenantSelfWithdrawThunks.list(queryParams));
    } catch (e) {
      console.log(e);
    }

    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button type="primary" icon={<PlusCircleTwoTone />} onClick={handleShow}>
        {t("domains.Transfer.createSelfWithdraw")}
      </Button>

      <Modal
        title={t("domains.Transfer.createSelfWithdraw")}
        open={isOpen}
        footer={[
          <div className="flex jc:end gap:8" key="footer">
            <Button key="back" onClick={handleCancel}>
              {t("systems.Action.cancel")}
            </Button>
            <Button key="submit" type="primary" onClick={handleConfirm}>
              {t("systems.Action.submit")}
            </Button>
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Form className="mt:16" form={form} labelCol={{ span: 6 }}>
          <Form.Item
            label={t("domains.Transfer.selfWithdrawAmount")}
            name="amount"
            rules={[
              {
                required: true,
                message: t("systems.Error.cannotBeEmpty", {
                  field: t("domains.Transfer.selfWithdrawAmount"),
                }),
              },
            ]}
          >
            <Input
              type="number"
              placeholder={t("systems.Placeholder.pleaseInput", {
                field: t("domains.Transfer.selfWithdrawAmount"),
              })}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
